module.exports = __webpack_public_path__ + "img/lglogo.f8facfb3.png";